import {Component, EventEmitter, Input, Output} from "@angular/core";
import {LoadingSpinnerComponent} from "../loading-spinner/loading-spinner.component";
import {CommonModule} from "@angular/common";

@Component({
    selector: 'db-loading-screen',
    templateUrl: './loading-screen.component.html',
    styleUrls: ['./loading-screen.component.scss'],
    standalone: true,
    imports: [
        LoadingSpinnerComponent,
        CommonModule
    ]
})
export class LoadingScreenComponent {
  @Input() loadingMessage: string;
  @Input() pageBlocker: boolean;
  @Input() fixed?: boolean;
  @Input() darkColor?: boolean = false;
  @Input() fullSize?: boolean;
  @Input() migration: boolean = false;
  @Input() autoSignup?: boolean = false;
  @Output() showManualStep = new EventEmitter<any>();

  public showManualForm() {
    this.showManualStep.emit();
  }

}
